import { subscriptionStatusSelect } from '@common/config/app-config';
import { useClientListStore } from '@common/store/hotel-list-store';
import { ComboboxItem, Select } from '@mantine/core';
import { isNil, find } from 'lodash-es';

export function FiltersStateSelect() {
  const paramKey = 'state';
  const { params, setParams, setFilters } = useClientListStore();

  function handleChange(option: ComboboxItem) {
    setFilters({ [paramKey]: isNil(option) ? undefined : option.label });
    setParams({ [paramKey]: isNil(option) ? undefined : Number(option.value) });
  }

  return (
    <Select
      searchable
      clearable
      variant="filled"
      label="State"
      placeholder="All States"
      value={find(subscriptionStatusSelect, { value: String(params[paramKey]) })?.value || null}
      data={subscriptionStatusSelect}
      onChange={(_value, option) => handleChange(option)}
      comboboxProps={{ withinPortal: false }}
    />
  );
}
